<rpe-vista-mis-integrantes [vistaMisIntegrantesInput]="vistaIntegrantesInput"></rpe-vista-mis-integrantes>